export default function actionSlider() {

    const actionSlider = document.querySelector('.js-actionSlider');

    if (!actionSlider) {
        return false;
    }

    function initActionSlider() {

        if (window.innerWidth > 768) {
            return false;
        }

        $('.js-actionSlider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'action_dots',
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initActionSlider);

}